module.exports = __webpack_public_path__ + "fbcbf4437d9a67648a3ac1d385f3acbe.otf";